import { Chip } from '@mui/material';
import DraftsOutlined from '@mui/icons-material/DraftsOutlined';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import PauseCircleOutlined from '@mui/icons-material/PauseCircleOutlined';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import { IntegrationState } from 'types/integration';

type ChipConfig = { icon: JSX.Element; label: string; color: string };

const STATE_CONFIG: Record<IntegrationState, ChipConfig> = {
  [IntegrationState.DRAFT]: {
    icon: <DraftsOutlined fontSize="small" />,
    label: 'Draft',
    color: '#2196F3',
  },
  [IntegrationState.ACTIVE]: {
    icon: <CheckCircleOutlined fontSize="small" />,
    label: 'Active',
    color: '#4CAF50',
  },
  [IntegrationState.SUSPENDED]: {
    icon: <PauseCircleOutlined fontSize="small" />,
    label: 'Suspended',
    color: '#FF9800',
  },
  [IntegrationState.ARCHIVED]: {
    icon: <Inventory2Outlined fontSize="small" />,
    label: 'Archived',
    color: '#F44336',
  },
};

const DELETION_IN_PROGRESS_CONFIG: ChipConfig = {
  icon: <DeleteOutlined fontSize="small" />,
  label: 'Deletion in Progress',
  color: '#F44336',
};

interface IntegrationStateIndicatorProps {
  state?: IntegrationState;
  deletionInProgress?: boolean;
}

export const IntegrationStateIndicator = ({
  state,
  deletionInProgress,
}: IntegrationStateIndicatorProps) => {
  const config = deletionInProgress
    ? DELETION_IN_PROGRESS_CONFIG
    : state
      ? STATE_CONFIG[state]
      : null;

  if (!config) return null;

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      size="small"
      variant="outlined"
      sx={{
        borderColor: config.color,
        color: config.color,
        '& .MuiChip-icon': {
          color: config.color,
        },
      }}
    />
  );
};

export default IntegrationStateIndicator;
